module.exports = __webpack_public_path__ + "static/media/Unity_logo.7b4fbbb0.png";